import {
  LayoutDashboard,
  FileText,
  Users,
  DollarSign,
  Building,
  PlusCircle,
  BarChart3,
  UserPlus,
  Target,
  Calendar,
  ShoppingCart,
  HeartHandshake,
  TrendingUp,
  UserCog,
  Wallet
} from "lucide-react";
import { RoleNavigationConfig, ROLES } from "@/features/auth/types";

export const roleNavigationConfig: RoleNavigationConfig = {
  [ROLES.LIDER_VENDAS]: {
    primary: [
      { title: "Dashboard", url: "/", icon: LayoutDashboard, badge: null },
      { title: "Pipeline", url: "/vendas/pipeline", icon: Target, badge: null },
      { title: "Agendamentos", url: "/agendamentos", icon: Calendar, badge: null },
      { title: "Clientes", url: "/clientes", icon: Users, badge: null }
    ],
    secondary: [
      { title: "Propostas", url: "/propostas", icon: FileText, badge: null }
    ],
    quickActions: [
      { icon: PlusCircle, label: "Novo Card", action: "navigate", url: "/vendas/pipeline?action=novo" },
      { icon: Users, label: "Novo Cliente", action: "navigate", url: "/clientes/novo" },
      { icon: Calendar, label: "Ver Agenda", action: "navigate", url: "/agendamentos" }
    ]
  },
  [ROLES.RELACIONADOR]: {
    primary: [
      { title: "Dashboard", url: "/", icon: LayoutDashboard, badge: null },
      { title: "Pipeline", url: "/vendas/pipeline", icon: Target, badge: null },
      { title: "Agendamentos", url: "/agendamentos", icon: Calendar, badge: null },
      { title: "Clientes", url: "/clientes", icon: Users, badge: null }
    ],
    secondary: [
      { title: "Propostas", url: "/propostas", icon: FileText, badge: null }
    ],
    quickActions: [
      { icon: PlusCircle, label: "Cadastrar Cliente", action: "navigate", url: "/clientes/novo" },
      { icon: Calendar, label: "Novo Agendamento", action: "navigate", url: "/agendamentos" },
      { icon: Target, label: "Repassar Lead", action: "modal", modal: "repassar-cliente" }
    ]
  },
  [ROLES.SECRETARIA]: {
    primary: [
      { title: "Dashboard", url: "/", icon: LayoutDashboard, badge: null },
      { title: "Pipeline", url: "/vendas/pipeline", icon: Target, badge: null },
      { title: "Agendamentos", url: "/agendamentos", icon: Calendar, badge: null },
      { title: "Clientes", url: "/clientes", icon: Users, badge: null },
      { title: "Grupos", url: "/grupos", icon: Building, badge: null },
      { title: "Bens", url: "/bens", icon: ShoppingCart, badge: null },
      { title: "Comissões", url: "/comissoes", icon: DollarSign, badge: null }
    ],
    secondary: [
      { title: "Propostas", url: "/propostas", icon: FileText, badge: null }
    ],
    quickActions: [
      { icon: BarChart3, label: "Relatórios", action: "navigate", url: "/relatorios" }
    ]
  },
  [ROLES.ASSOCIADO]: {
    primary: [
      { title: "Dashboard", url: "/", icon: LayoutDashboard, badge: null },
      { title: "Pipeline", url: "/vendas/pipeline", icon: Target, badge: null },
      { title: "Agendamentos", url: "/agendamentos", icon: Calendar, badge: null },
      { title: "Clientes", url: "/clientes", icon: Users, badge: null },
      { title: "Gestão", url: "/meu-time", icon: Users, badge: null }
    ],
    secondary: [
      { title: "Propostas", url: "/propostas", icon: FileText, badge: null },
      { title: "Relatórios", url: "/relatorios", icon: BarChart3, badge: null }
    ],
    quickActions: [
      { icon: PlusCircle, label: "Novo Card", action: "navigate", url: "/vendas/pipeline?action=novo" },
      { icon: Users, label: "Novo Cliente", action: "navigate", url: "/clientes/novo" },
      { icon: UserPlus, label: "Novo Usuário", action: "navigate", url: "/meu-time?tab=equipe&action=convidar" },
      { icon: Calendar, label: "Novo Agendamento", action: "navigate", url: "/agendamentos" }
    ]
  },
  [ROLES.SUPERVISOR]: {
    primary: [
      { title: "Dashboard", url: "/", icon: LayoutDashboard, badge: null },
      { title: "Supervisão", url: "/vendas/supervisao", icon: TrendingUp, badge: null },
      { title: "Pipeline", url: "/vendas/pipeline", icon: Target, badge: null },
      { title: "Agendamentos", url: "/agendamentos", icon: Calendar, badge: null },
      { title: "Clientes", url: "/clientes", icon: Users, badge: null }
    ],
    secondary: [
      { title: "Equipe", url: "/meu-time", icon: UserCog, badge: null },
      { title: "Propostas", url: "/propostas", icon: FileText, badge: null }
    ],
    quickActions: [
      { icon: PlusCircle, label: "Novo Card", action: "navigate", url: "/vendas/pipeline?action=novo" },
      { icon: Users, label: "Novo Cliente", action: "navigate", url: "/clientes/novo" },
      { icon: UserPlus, label: "Novo Usuário", action: "navigate", url: "/meu-time?tab=equipe&action=convidar" },
      { icon: Calendar, label: "Novo Agendamento", action: "navigate", url: "/agendamentos" }
    ]
  },
  [ROLES.REPRESENTANTE]: {
    primary: [
      { title: "Dashboard", url: "/", icon: LayoutDashboard, badge: null },
      { title: "Pipeline", url: "/vendas/pipeline", icon: Target, badge: null },
      { title: "Gestão", url: "/meu-time", icon: Users, badge: null }
    ],
    secondary: [
      { title: "Fluxo de Caixa", url: "/financeiro/fluxo-caixa", icon: Wallet, badge: null }
    ],
    quickActions: [
      { icon: UserPlus, label: "Convidar Usuário", action: "navigate", url: "/meu-time?tab=equipe&action=convidar" }
    ]
  },
  [ROLES.SUPER_ADMIN]: {
    primary: [
      { title: "Dashboard", url: "/", icon: LayoutDashboard, badge: null },
      { title: "Pipeline", url: "/vendas/pipeline", icon: Target, badge: null }
    ],
    secondary: [
      { title: "Comissões", url: "/comissoes", icon: DollarSign, badge: null },
      { title: "Gestão de Usuários", url: "/superadmin", icon: Users, badge: null },
      { title: "Fluxo de Caixa", url: "/financeiro/fluxo-caixa", icon: Wallet, badge: null }
    ],
    quickActions: []
  },
  [ROLES.POS_VENDA]: {
    primary: [
      { title: "Dashboard", url: "/", icon: LayoutDashboard, badge: null },
      { title: "Pipeline", url: "/vendas/pipeline", icon: Target, badge: null },
      { title: "Pós-Venda", url: "/pos-venda", icon: HeartHandshake, badge: null },
      { title: "Clientes", url: "/clientes", icon: Users, badge: null }
    ],
    secondary: [],
    quickActions: [
      { icon: BarChart3, label: "Acompanhamento", action: "navigate", url: "/pos-venda" }
    ]
  },
};
